/**
 * What a reading leaves on screen, and how to take it down.
 *
 * The card deck stayed up after Finish Reading: the chat-window Finish path
 * cleared the reading, the picks and the focus, but never `showCardDeck`, and
 * the landing layout is gated on the deck being gone — so the seeker finished
 * a reading and landed on a black canvas with a lone "Reading" tile and the
 * nav still collapsed. Every flag a reading raises is listed here, once, so
 * the two Finish paths (chat control, reading's own close) cannot drift.
 */
export const READING_SURFACE_FLAGS = [
  'showCardDeck', 'layerShowCardSelection', 'selecting_cards',
  'showReadingComponent', 'showFullReading',
]
// readingIsReady is deliberately not here: it arrives over the socket and can
// land before the reading mounts (which also resets the surface); the two
// Finish paths lower it themselves.

/** Lower every reading flag on a map of refs (missing keys are skipped). */
export function lowerReadingSurface (refs) {
  for (const key of READING_SURFACE_FLAGS) {
    const r = refs && refs[key]
    if (r && typeof r === 'object' && 'value' in r) r.value = false
  }
}

/** True when nothing a reading raised is still on screen. */
export function readingSurfaceDown (flags) {
  return READING_SURFACE_FLAGS.every(k => !(flags && flags[k]))
}
